import React from "react";
import { convertStringToArray } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const VideoGalleryEnv = ({ data }) => {
  console.log(data);
  const videoArray = convertStringToArray(data?.field_environment_videos);
  console.log(videoArray);
  const { getText } = useLanguageTranslation();

  return (
    <>
      <div className="container">
        <div className="title-sec">
          <h4>{data.title}</h4>
        </div>
        <div className="row mb-5">
          {videoArray?.length === 0 ? (
            <div className="container">
              <div className="">
                <h4 className="title4">
                  {getText("No Video available", "कोई वीडियो उपलब्ध नहीं")}
                </h4>
              </div>
            </div>
          ) : (
            videoArray.map((item, index) => (
              <div
                className="col-12 col-sm-12 col-md-4 col-lg-4 mvDescWrap"
                key={index}
              >
                <div className="photo-gallery-area video-card">
                  <div className="card-sec">
                    <div className="img-sec">
                      <video
                        width="100%"
                        height="auto%"
                        controls={true}
                        // autoPlay={true}
                        loop={true}
                        muted={true}
                      >
                        <source
                          src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-08/${item.file_path}`}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    {/* <div className="desc-sec">
                      <p>{item?.title}</p>
                    </div> */}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default VideoGalleryEnv;
